import { TFunction } from "i18next";
import defaultMenuImage from "@/assets/default-menu-item.webp";
import { Category } from "@/model/entities";

export const getDefaultCategories = (t: TFunction): Category[] => [
  {
    id: "demo-category",
    name: t("demo.categoryName", "Demo Items"),
    description: t(
      "demo.categoryDescription",
      "Sample menu items to show how your menu will look",
    ),
    isHidden: false,
    items: [
      {
        id: "demo-item-1",
        name: t("demo.item1Name", "Sample Dish"),
        description: t(
          "demo.item1Description",
          "This is how your menu item description will appear",
        ),
        price: 15.99,
        imageUrl: defaultMenuImage,
        isAvailable: true,
      },
      {
        id: "demo-item-2",
        name: t("demo.item2Name", "Another Sample"),
        description: t(
          "demo.item2Description",
          "Add your own items to replace these demo items",
        ),
        price: 12.5,
        imageUrl: defaultMenuImage,
        isAvailable: true,
      },
    ],
  },
];

export const getDummyDevelopmentCategories = (t: TFunction): Category[] => [
  {
    id: "appetizers",
    name: t("categories.appetizers", "מנות פתיחה"),
    description: t("categories.appetizers.description", "מנות להתחלה מושלמת"),
    isHidden: false,
    items: [
      {
        id: "app-1",
        name: t("items.hummus", "חומוס בית"),
        description: t(
          "items.hummus.desc",
          "חומוס קרמי עם טחינה, שמן זית ופיתה חמה",
        ),
        price: 18,
        imageUrl:
          "https://images.unsplash.com/photo-1571091655789-405eb7a3a3a8?w=400&h=300&fit=crop&auto=format",
        isAvailable: true,
      },
      {
        id: "app-2",
        name: t("items.falafel", "פלאפל"),
        description: t(
          "items.falafel.desc",
          "כדורי חומוס מטוגנים בשמן עמוק עם ירקות טריים",
        ),
        price: 22,
        imageUrl:
          "https://images.unsplash.com/photo-1571091655789-405eb7a3a3a8?w=400&h=300&fit=crop&auto=format",
        isAvailable: true,
      },
      {
        id: "app-3",
        name: t("items.baba_ganoush", "בבא גנוש"),
        description: t(
          "items.baba_ganoush.desc",
          "ממרח חצילים קלויים עם טחינה ושום",
        ),
        price: 16,
        imageUrl:
          "https://images.unsplash.com/photo-1571091655789-405eb7a3a3a8?w=400&h=300&fit=crop&auto=format",
        isAvailable: false,
      },
      {
        id: "app-4",
        name: t("items.tabbouleh", "טבולה"),
        description: t(
          "items.tabbouleh.desc",
          "סלט פרש של פטרוזיליה, מנטה, עגבניות ובורגול",
        ),
        price: 20,
        imageUrl:
          "https://images.unsplash.com/photo-1571091655789-405eb7a3a3a8?w=400&h=300&fit=crop&auto=format",
        isAvailable: true,
      },
    ],
  },
  {
    id: "mains",
    name: t("categories.mains", "מנות עיקריות"),
    description: t("categories.mains.description", "המנות הראשיות שלנו"),
    isHidden: false,
    items: [
      {
        id: "main-1",
        name: t("items.schnitzel", "שניצל עוף"),
        description: t(
          "items.schnitzel.desc",
          "פרוסת עוף רכה בציפוי פירורי לחם זהוב",
        ),
        price: 45,
        imageUrl:
          "https://images.unsplash.com/photo-1562967914-608f82629710?w=400&h=300&fit=crop&auto=format",
        isAvailable: true,
      },
      {
        id: "main-2",
        name: t("items.shawarma", "שווארמה בלאפה"),
        description: t(
          "items.shawarma.desc",
          "בשר טלה או עוף מתובל בלאפה עם סלטים",
        ),
        price: 35,
        imageUrl:
          "https://images.unsplash.com/photo-1529059997568-3d847b1154f0?w=400&h=300&fit=crop&auto=format",
        isAvailable: true,
      },
      {
        id: "main-3",
        name: t("items.kebab", "קבב"),
        description: t("items.kebab.desc", "קבב בשר טחון מתובל על האש עם אורז"),
        price: 48,
        imageUrl:
          "https://images.unsplash.com/photo-1544025162-d76694265947?w=400&h=300&fit=crop&auto=format",
        isAvailable: true,
      },
      {
        id: "main-4",
        name: t("items.fish", "דג של היום"),
        description: t(
          "items.fish.desc",
          "דג טרי של היום מוכן על הגריל עם ירקות עונתיים",
        ),
        price: 55,
        imageUrl:
          "https://images.unsplash.com/photo-1519708227418-c8fd9a32b7a2?w=400&h=300&fit=crop&auto=format",
        isAvailable: true,
      },
      {
        id: "main-5",
        name: t("items.pasta", "פסטה ארביאטה"),
        description: t(
          "items.pasta.desc",
          "פסטה ברוטב עגבניות חריף עם בזיליקום טרי",
        ),
        price: 38,
        imageUrl:
          "https://images.unsplash.com/photo-1571091655789-405eb7a3a3a8?w=400&h=300&fit=crop&auto=format",
        isAvailable: false,
      },
    ],
  },
  {
    id: "desserts",
    name: t("categories.desserts", "קינוחים"),
    description: t("categories.desserts.description", "קינוחים מתוקים לסיום"),
    isHidden: false,
    items: [
      {
        id: "dess-1",
        name: t("items.baklava", "בקלאווה"),
        description: t(
          "items.baklava.desc",
          "מאפה פילו במילוי אגוזים וסירוב דבש",
        ),
        price: 25,
        imageUrl:
          "https://images.unsplash.com/photo-1571091655789-405eb7a3a3a8?w=400&h=300&fit=crop&auto=format",
        isAvailable: true,
      },
      {
        id: "dess-2",
        name: t("items.tiramisu", "טירמיסו"),
        description: t(
          "items.tiramisu.desc",
          "קינוח איטלקי קלאסי עם קפה ומסקרפונה",
        ),
        price: 28,
        imageUrl:
          "https://images.unsplash.com/photo-1571877227200-a0d98ea607e9?w=400&h=300&fit=crop&auto=format",
        isAvailable: true,
      },
      {
        id: "dess-3",
        name: t("items.chocolate_cake", "עוגת שוקולד"),
        description: t(
          "items.chocolate_cake.desc",
          "עוגת שוקולד עשירה עם גנאש",
        ),
        price: 30,
        imageUrl:
          "https://images.unsplash.com/photo-1578985545062-69928b1d9587?w=400&h=300&fit=crop&auto=format",
        isAvailable: true,
      },
    ],
  },
  {
    id: "beverages",
    name: t("categories.beverages", "משקאות"),
    description: t("categories.beverages.description", "משקאות קרים וחמים"),
    isHidden: false,
    items: [
      {
        id: "bev-1",
        name: t("items.coffee", "קפה טורקי"),
        description: t("items.coffee.desc", "קפה טורקי מסורתי חזק וארומטי"),
        price: 12,
        imageUrl:
          "https://images.unsplash.com/photo-1509042239860-f550ce710b93?w=400&h=300&fit=crop&auto=format",
        isAvailable: true,
      },
      {
        id: "bev-2",
        name: t("items.tea", "תה מנטה"),
        description: t("items.tea.desc", "תה ירוק עם עלי מנטה טריים"),
        price: 10,
        imageUrl:
          "https://images.unsplash.com/photo-1556679343-c7306c1976bc?w=400&h=300&fit=crop&auto=format",
        isAvailable: true,
      },
      {
        id: "bev-3",
        name: t("items.juice", "מיץ רימונים טרי"),
        description: t("items.juice.desc", "מיץ רימונים טבעי וטרי"),
        price: 15,
        imageUrl:
          "https://images.unsplash.com/photo-1622597467836-f3285f2131b8?w=400&h=300&fit=crop&auto=format",
        isAvailable: true,
      },
      {
        id: "bev-4",
        name: t("items.water", "מים מינרליים"),
        description: t("items.water.desc", "מים מינרליים טבעיים"),
        price: 8,
        imageUrl:
          "https://images.unsplash.com/photo-1523362628745-0c100150b504?w=400&h=300&fit=crop&auto=format",
        isAvailable: true,
      },
      {
        id: "bev-5",
        name: t("items.soda", "משקה קל"),
        description: t("items.soda.desc", "קוקה קולה, ספרייט או פאנטה"),
        price: 12,
        imageUrl:
          "https://images.unsplash.com/photo-1581636625402-29b2a704ef13?w=400&h=300&fit=crop&auto=format",
        isAvailable: true,
      },
    ],
  },
  {
    id: "salads",
    name: t("categories.salads", "סלטים"),
    description: t("categories.salads.description", "סלטים טריים ובריאים"),
    isHidden: false,
    items: [
      {
        id: "sal-1",
        name: t("items.fattoush", "סלט פתוש"),
        description: t(
          "items.fattoush.desc",
          "סלט ירקות עם לחם קלוי ורוטב לימון",
        ),
        price: 24,
        imageUrl:
          "https://images.unsplash.com/photo-1504754524776-8f4f37790ca0?w=400&h=300&fit=crop&auto=format",
        isAvailable: true,
      },
    ],
  },
  {
    id: "sides",
    name: t("categories.sides", "תוספות"),
    description: t("categories.sides.description", "תוספות להשלמת הארוחה"),
    isHidden: false,
    items: [
      {
        id: "side-1",
        name: t("items.fries", "צ'יפס פריך"),
        description: t("items.fries.desc", "צ'יפס זהוב ומתובל"),
        price: 12,
        imageUrl:
          "https://images.unsplash.com/photo-1542444459-db1b9a2f6b39?w=400&h=300&fit=crop&auto=format",
        isAvailable: true,
      },
      {
        id: "side-2",
        name: t("items.salad_side", "סלט קטן"),
        description: t("items.salad_side.desc", "מנת סלט אישית רעננה"),
        price: 10,
        imageUrl:
          "https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=400&h=300&fit=crop&auto=format",
        isAvailable: true,
      },
    ],
  },
  {
    id: "sandwiches",
    name: t("categories.sandwiches", "כריכים"),
    description: t("categories.sandwiches.description", "כריכים טריים וטעימים"),
    isHidden: false,
    items: [
      {
        id: "sand-1",
        name: t("items.blta", "BLT עם ביצה"),
        description: t(
          "items.blta.desc",
          "בייקון, חסה, עגבנייה וביצה על לחם טרי",
        ),
        price: 30,
        imageUrl:
          "https://images.unsplash.com/photo-1550317138-10000687a72b?w=400&h=300&fit=crop&auto=format",
        isAvailable: true,
      },
      {
        id: "sand-2",
        name: t("items.chicken_wrap", "וראפ עוף"),
        description: t(
          "items.chicken_wrap.desc",
          "חזה עוף, ירקות ורוטב מיוחד בטרי",
        ),
        price: 28,
        imageUrl:
          "https://images.unsplash.com/photo-1544025162-d76694265947?w=400&h=300&fit=crop&auto=format",
        isAvailable: true,
      },
    ],
  },
  {
    id: "kids",
    name: t("categories.kids", "ילדים"),
    description: t("categories.kids.description", "מנות קטנות ומתאימות לילדים"),
    isHidden: false,
    items: [
      {
        id: "kid-1",
        name: t("items.kids_nuggets", "נאגטס ילדים"),
        description: t(
          "items.kids_nuggets.desc",
          "מנת נאגטס פריכה עם צ'יפס קטן",
        ),
        price: 18,
        imageUrl:
          "https://images.unsplash.com/photo-1562967914-608f82629710?w=400&h=300&fit=crop&auto=format",
        isAvailable: true,
      },
      {
        id: "kid-2",
        name: t("items.kids_pasta", "פסטה ילדים"),
        description: t("items.kids_pasta.desc", "פסטה ברוטב עגבניות פשוט"),
        price: 16,
        imageUrl:
          "https://images.unsplash.com/photo-1578985545062-69928b1d9587?w=400&h=300&fit=crop&auto=format",
        isAvailable: true,
      },
    ],
  },
];
